import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import remarkBreaks from "remark-breaks";

interface LLMOutputProps {
  content: string;
  className?: string;
}

const LLMOutput: React.FC<LLMOutputProps> = ({ content, className = "" }) => {
  return (
    <div className={`llm-output-container ${className}`}>
      <div className="llm-output-content max-w-none overflow-x-auto">
        <style dangerouslySetInnerHTML={{
          __html: `
            .llm-output-content table {
              border: 2px solid #374151 !important;
              background: white !important;
              border-collapse: separate !important;
              border-spacing: 0 !important;
              border-radius: 8px !important;
              width: 100% !important;
              margin: 1rem 0 !important;
              box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
            }
            .llm-output-content th {
              border: 1px solid #6b7280 !important;
              border-bottom: 2px solid #374151 !important;
              background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%) !important;
              padding: 0.75rem 1rem !important;
              font-weight: 700 !important;
              color: #111827 !important;
            }
            .llm-output-content td {
              border: 1px solid #d1d5db !important;
              border-bottom: 1px solid #9ca3af !important;
              background: white !important;
              padding: 0.75rem 1rem !important;
              color: #374151 !important;
            }
            .llm-output-content tbody tr:nth-child(even) {
              background: #f9fafb !important;
            }
            .llm-output-content tbody tr:hover {
              background: #eff6ff !important;
              transform: scale(1.01) !important;
              transition: all 0.2s ease-in-out !important;
            }
            .llm-output-content thead th:first-child {
              border-top-left-radius: 8px !important;
            }
            .llm-output-content thead th:last-child {
              border-top-right-radius: 8px !important;
            }
            .llm-output-content tbody tr:last-child td:first-child {
              border-bottom-left-radius: 8px !important;
            }
            .llm-output-content tbody tr:last-child td:last-child {
              border-bottom-right-radius: 8px !important;
            }
          `
        }} />
        <ReactMarkdown 
          remarkPlugins={[remarkGfm, remarkBreaks]} 
          rehypePlugins={[rehypeRaw]}
        >
          {content}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default LLMOutput;

